import { NavigateOptions, useLocation, useNavigate } from 'react-router';
import { useCallback } from 'react';
import isNil from 'lodash/isNil';
import { appRoutes } from '../constants/appRoutes';

const useSweepNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = useCallback(() => {
    const { state } = location;
    let destinationPath: string | undefined = undefined;
    if (state) {
      Object.entries(state).forEach((entry) => {
        const [key, value] = entry as [string, string];
        if (key === 'from') {
          destinationPath = value;
        }
      });
    }

    navigate(destinationPath ?? appRoutes.home.route);
  }, [location, navigate]);

  const navigateWithHistory = useCallback(
    (destination: string, options?: NavigateOptions) => {
      const { ...navigateOptions } = options ?? {};

      return navigate(destination, {
        state: { from: window.location.pathname + window.location.search },
        ...navigateOptions,
      });
    },
    [navigate],
  );
  const removeQueryParams = useCallback(
    (paramsToDelete: string[]) => {
      const location = window.location;
      const updatedSearchParams = new URLSearchParams(location.search);
      paramsToDelete.forEach((param) => {
        if (!isNil(updatedSearchParams.get(param))) {
          updatedSearchParams.delete(param);
        }
      });
      navigate(`${location.pathname}?${updatedSearchParams.toString()}`);
    },
    [navigate],
  );

  return { goBack, navigate: navigateWithHistory, removeQueryParams };
};

export default useSweepNavigate;
